import { render, staticRenderFns } from "./ManageDynamicForms.vue?vue&type=template&id=453e1a6f"
import script from "./ManageDynamicForms.vue?vue&type=script&lang=js"
export * from "./ManageDynamicForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports